import { useEffect, type ReactNode } from "react";

import { useComboboxLegacy } from "./ComboboxLegacy";

export type ComboboxLegacyEmptyProps = {
  children?: ReactNode;
};

export const ComboboxLegacyEmpty = function <Item = any>({
  children,
}: ComboboxLegacyEmptyProps) {
  const { items, setHasEmpty } = useComboboxLegacy<Item>();

  useEffect(() => {
    setHasEmpty?.(true);

    return () => {
      setHasEmpty?.(false);
    };
  });

  return !items.length ? children : null;
};
